// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.background {
  position: absolute;
  z-index: -1;
  height: 100%;
  width: 100%;
}

.common-info__container {
  display: flex;
  position: relative;
  align-items: stretch;
  justify-content: center;
  background-color: transparent;
}
.common-info__container.mobile {
  background-color: #1B1B1B;
}

.common-info__content {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: flex-start;
}

.text-block__first {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-family: Inter, serif;
  font-weight: 700;
  text-shadow: 0 0 9px rgba(28, 33, 46, 0.24);
  color: var(--text-color-1);
}
.text-block__first :last-child {
  display: none;
}
.text-block__first .text-block__line {
  display: inline-flex;
  align-items: center;
}
.text-block__first .text-block__line .circle:last-child {
  display: none;
}
.text-block__first .text-block__line > * {
  white-space: nowrap;
}

.circle {
  background-color: var(--text-color-1);
  border-radius: 6px;
}

.text-block__second {
  color: var(--white-color);
}
.text-block__second span {
  color: var(--accent-color);
}

.text-block__third {
  color: var(--secondary-text-color);
  text-shadow: 0 0 9px rgba(28, 33, 46, 0.24);
}

@media only screen and (min-device-width: 320px) {
  .common-info__container {
    min-width: 320px;
  }
  .common-info__container > div:last-child {
    padding: 55px 5% 76px 5%;
  }
  .common-info__content {
    gap: 20px;
  }
  .text-block__first {
    gap: 12px 24px;
    width: 268px;
    font-size: 12px;
    line-height: 16.8px;
    letter-spacing: 0.6px;
  }
  .text-block__first :nth-child(4) {
    display: none;
  }
  .text-block__line {
    height: -moz-fit-content;
    height: fit-content;
    gap: 24px;
  }
  .circle {
    width: 6px;
    height: 6px;
  }
}
@media only screen and (min-device-width: 768px) {
  .common-info__container {
    min-width: 768px;
  }
  .common-info__container > div:last-child {
    padding: 86px 6.9% 119px 6.9%;
  }
  .common-info__content {
    gap: 36px;
  }
  .text-block__first {
    gap: 16px 24px;
    width: 338px;
    font-size: 16px;
    line-height: 22.4px;
    letter-spacing: 0.8px;
  }
  .text-block__first :nth-child(4) {
    display: none;
  }
  .circle {
    width: 6px;
    height: 6px;
  }
}
@media only screen and (min-device-width: 992px) {
  .common-info__container {
    min-width: 992px;
  }
  .common-info__container > div:last-child {
    padding: 117px 8.7% 173px 8.7%;
  }
  .common-info__content {
    gap: 44px;
  }
  .text-block__first {
    width: 100%;
    gap: 32px;
    font-size: 18px;
    line-height: 25.2px;
    letter-spacing: 0.9px;
  }
  .text-block__first :nth-child(4) {
    display: block;
  }
  .circle {
    width: 8px;
    height: 8px;
  }
}
@media only screen and (min-device-width: 1366px) {
  .common-info__container {
    min-width: 1366px;
  }
  .common-info__container > div:last-child {
    padding: 172px 9.8% 216px;
  }
  .common-info__content {
    max-height: 100%;
    gap: 52px;
  }
  .text-block__first {
    gap: 32px;
    width: 100%;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: 1px;
  }
  .text-block__first :nth-child(4) {
    display: block;
  }
  .circle {
    width: 8px;
    height: 8px;
  }
}
@media only screen and (min-device-width: 1366px) {
  .common-info__container > div:last-child {
    padding: 172px 190.5px 216px 190.5px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/LandingPage/components/CommonInfo/commonInfo.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EAGA,YAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,6BAAA;AADF;AAEE;EACE,yBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;AADF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,2CAAA;EACA,0BAAA;AAFF;AAGE;EACE,aAAA;AADJ;AAGE;EACE,oBAAA;EACA,mBAAA;AADJ;AAGI;EACE,aAAA;AADN;AAII;EACE,mBAAA;AAFN;;AAOA;EACE,qCAAA;EACA,kBAAA;AAJF;;AAOA;EACE,yBAAA;AAJF;AAME;EACE,0BAAA;AAJJ;;AAQA;EACE,kCAAA;EACA,2CAAA;AALF;;AAOA;EACE;IACE,gBAAA;EAJF;EAKK;IACA,wBAAA;EAHL;EAMA;IACE,SAAA;EAJF;EAMA;IACE,cAAA;IACA,YAAA;IAEA,eAAA;IACA,mBAAA;IACA,qBAAA;EALF;EAME;IACE,aAAA;EAJJ;EAOA;IACE,wBAAA;IAAA,mBAAA;IACA,SAAA;EALF;EAOA;IACE,UAAA;IACA,WAAA;EALF;AACF;AAQA;EACE;IACE,gBAAA;EANF;EASM;IACE,6BAAA;EAPR;EAUA;IACE,SAAA;EARF;EAUA;IACE,cAAA;IACA,YAAA;IAEA,eAAA;IACA,mBAAA;IACA,qBAAA;EATF;EAUE;IACE,aAAA;EARJ;EAWA;IACE,UAAA;IACA,WAAA;EATF;AACF;AAYA;EACE;IACE,gBAAA;EAVF;EAaE;IACE,8BAAA;EAXJ;EAcA;IACE,SAAA;EAZF;EAcA;IACE,WAAA;IACA,SAAA;IAEA,eAAA;IACA,mBAAA;IACA,qBAAA;EAbF;EAcE;IACE,cAAA;EAZJ;EAeA;IACE,UAAA;IACA,WAAA;EAbF;AACF;AAgBA;EACE;IACE,iBAAA;EAdF;EAiBE;IACE,yBAAA;EAfJ;EAkBA;IACE,gBAAA;IACA,SAAA;EAhBF;EAkBA;IACE,SAAA;IACA,WAAA;IAEA,eAAA;IACA,iBAAA;IACA,mBAAA;EAjBF;EAkBE;IACE,cAAA;EAhBJ;EAmBA;IACE,UAAA;IACA,WAAA;EAjBF;AACF;AAmBA;EAEI;IACE,oCAAA;EAlBJ;AACF","sourcesContent":[".background{\n  position: absolute;\n  z-index: -1;\n  //display: flex;\n  //flex-direction: column;\n  height: 100%;\n  width: 100%;\n\n}\n.common-info__container {\n  display: flex;\n  position: relative;\n  align-items: stretch;\n  justify-content: center;\n  background-color: transparent;\n  &.mobile{\n    background-color: #1B1B1B;\n  }\n  //background-color: #1B1B1B;\n}\n.common-info__content {\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  align-items: flex-start;\n  //justify-content: center;\n}\n\n.text-block__first {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  font-family: Inter, serif;\n  font-weight: 700;\n  text-shadow: 0 0 9px rgba(28, 33, 46, 0.24);\n  color: var(--text-color-1);\n  :last-child{\n    display: none;\n  }\n  .text-block__line {\n    display: inline-flex;\n    align-items: center;\n\n    .circle:last-child {\n      display: none;\n    }\n\n    & > * {\n      white-space: nowrap;\n    }\n  }\n}\n\n.circle {\n  background-color: var(--text-color-1);\n  border-radius: 6px\n}\n\n.text-block__second {\n  color: var(--white-color);\n\n  span {\n    color: var(--accent-color)\n  }\n}\n\n.text-block__third{\n  color: var(--secondary-text-color);\n  text-shadow: 0 0 9px rgba(28, 33, 46, 0.24);\n}\n@media only screen and (min-device-width: 320px) {\n  .common-info__container {\n    min-width: 320px;\n       & > div:last-child {\n       padding: 55px 5% 76px 5%;\n    }\n  }\n  .common-info__content {\n    gap: 20px;\n  }\n  .text-block__first {\n    gap: 12px 24px;\n    width: 268px;\n\n    font-size: 12px;\n    line-height: 16.8px;\n    letter-spacing: 0.6px;\n    :nth-child(4){\n      display: none;\n    }\n  }\n  .text-block__line {\n    height: fit-content;\n    gap: 24px;\n  }\n  .circle {\n    width: 6px;\n    height: 6px;\n  }\n}\n\n@media only screen and (min-device-width: 768px) {\n  .common-info__container {\n    min-width: 768px;\n  }\n      .common-info__container {\n        & > div:last-child {\n          padding: 86px 6.9% 119px 6.9%;\n        }\n      }\n  .common-info__content {\n    gap: 36px;\n  }\n  .text-block__first {\n    gap: 16px 24px;\n    width: 338px;\n\n    font-size: 16px;\n    line-height: 22.4px;\n    letter-spacing: 0.8px;\n    :nth-child(4){\n      display: none;\n    }\n  }\n  .circle {\n    width: 6px;\n    height: 6px;\n  }\n}\n\n@media only screen and (min-device-width: 992px) {\n  .common-info__container {\n    min-width: 992px;\n  }\n    .common-info__container {\n    & > div:last-child {\n      padding: 117px 8.7% 173px 8.7%;\n    }\n  }\n  .common-info__content {\n    gap: 44px;\n  }\n  .text-block__first {\n    width: 100%;\n    gap: 32px;\n\n    font-size: 18px;\n    line-height: 25.2px;\n    letter-spacing: 0.9px;\n    :nth-child(4){\n      display: block;\n    }\n  }\n  .circle {\n    width: 8px;\n    height: 8px;\n  }\n}\n\n@media only screen and (min-device-width: 1366px) {\n  .common-info__container {\n    min-width: 1366px;\n  }\n  .common-info__container {\n    & > div:last-child {\n      padding: 172px 9.8% 216px;\n    }\n  }\n  .common-info__content {\n    max-height: 100%;\n    gap: 52px;\n  }\n  .text-block__first {\n    gap: 32px;\n    width: 100%;\n\n    font-size: 20px;\n    line-height: 28px;\n    letter-spacing: 1px;\n    :nth-child(4){\n      display: block;\n    }\n  }\n  .circle {\n    width: 8px;\n    height: 8px;\n  }\n}\n@media only screen and (min-device-width: 1366px) {\n    .common-info__container {\n    & > div:last-child {\n      padding: 172px 190.5px 216px 190.5px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
